import {IconProps} from "types/types";

export default function ArrowRightIcon({
                                      color = "#000",
                                      size = 20,
                                      className,
                                      style
                                  }: IconProps) {
    return <svg className={className} style={style} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M11.4733 3.97314L10.7367 4.70971L15.3734 9.34641L3.15374 9.34641L3.15374 10.385L15.3734 10.385L10.7367 15.0217L11.4733 15.7583L17.3658 9.8657L11.4733 3.97314Z"
              fill={color}/>
    </svg>

}